import React from 'react';
import {
  WrapperStyle,
  DescriptionStyle,
  Title,
  SeparatorStyle,
} from '../../resources/styling/surveyReportStyle';
import ReportScores from './ReportScores';
import RoleWiseReportScores from './RoleWiseReportScores';
import SuggestedPriorityActionsView from './SuggestedPriorityActionsView';
import {
  ViewIndividualAnswers,
  AreasForReviewAndPossibleFocus,
} from './Constants';
import ReportResultsSection from './ReportResultsSection';
import {
  limitAverageValue,
  scoreNotAvailableValue,
} from '../../utils/roundScore';

const DemandReport = ({ report, onButtonClick, isPaid }) => {
  const {
    ResultsText,
    HseStrengths,
    HseWeaknesses,
    SchoolStrengths,
    SchoolWeaknesses,
    SuggestedPriorityActions,
    Score,
  } = report;
  return (
    <WrapperStyle id='demandsData' className='demands-data'>
      <h1 className='report-title'>1. Demands</h1>
      <p id='demandsTitle'>
        This includes issues such as workload, work patterns, working hours and
        the work environment.
      </p>
      <button data-test-id='demandsReport' onClick={onButtonClick}>
        {ViewIndividualAnswers}
      </button>
      <p id='demandsTitle' style={{ 'text-align': 'center' }}>
        Overall Scores and Deciles
      </p>
      <ReportScores
        Score={Score}
        id='demandsScore'
        className='report-score'
        isPaid={isPaid}
      />
      {scoreNotAvailableValue(
        limitAverageValue(Score.SupportStaffClassCatAvg)
      ) === '-1.00' &&
      scoreNotAvailableValue(
        limitAverageValue(Score.SupportStaffNonClassCatAvg)
      ) === '-1.00' &&
      scoreNotAvailableValue(
        limitAverageValue(Score.TeachingStaffClassCatAvg)
      ) === '-1.00' &&
      scoreNotAvailableValue(
        limitAverageValue(Score.TeachingStaffNonClassCatAvg)
      ) === '-1.00' &&
      scoreNotAvailableValue(limitAverageValue(Score.MiddleLeaderCatAvg)) ===
        '-1.00' &&
      scoreNotAvailableValue(limitAverageValue(Score.SeniorLeaderCatAvg)) ===
        '-1.00' ? (
        ''
      ) : (
        <>
          <br />
          <p id='demandsTitle' style={{ 'text-align': 'center' }}>
            Scores by Job Role
          </p>
          <RoleWiseReportScores
            Score={Score}
            id='RoleWisedemandsScore'
            className='report-score'
          />
        </>
      )}
      <DescriptionStyle id='demandsDescription' className='demand-description'>
        <h1>Description</h1>
        <Title className='description-title'>
          The Management Standard is that:
        </Title>
        <ul className='report-list-wrapper'>
          <li>
            Staff should indicate that they are able to cope with the demands of
            their jobs.
          </li>
          <li>
            Systems are in place locally to respond to any individual concerns.
          </li>
        </ul>
        <Title className='description-title'>
          This means that where possible:
        </Title>
        <ul className='report-list-wrapper'>
          <li>
            The school provides staff with adequate and achievable demands in
            relation to their agreed hours of work.
          </li>
          <li>
            People's skills and abilities are matched to their job demands.
          </li>
          <li>Jobs are designed to be within the capabilities of staff.</li>
          <li>Staff concerns about their work environment are addressed.</li>
        </ul>
      </DescriptionStyle>

      {isPaid ? (
        <div>
          <SeparatorStyle />
          <ReportResultsSection
            id='demandsResults'
            ResultsText={ResultsText}
            SchoolStrengths={SchoolStrengths}
            SchoolWeaknesses={SchoolWeaknesses}
            HseStrengths={HseStrengths}
            HseWeaknesses={HseWeaknesses}
            AreasForReviewAndPossibleFocus={AreasForReviewAndPossibleFocus}
          />
        </div>
      ) : null}

      {isPaid ? (
        <div>
          <SeparatorStyle />
          <SuggestedPriorityActionsView
            id='demandsSuggestions'
            heading='Suggested Priority Actions for Demands'
            SuggestedPriorityActions={SuggestedPriorityActions}
          />
        </div>
      ) : null}
      <div id='control' />
    </WrapperStyle>
  );
};

export default DemandReport;
